import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
    poemListContainer: {
        margin: "0 auto",
        width: "100%",
        position: "absolute"
    }
}));

export default useStyles;